import { render, staticRenderFns } from "./ItemPool.vue?vue&type=template&id=d27f2e2a&scoped=true&"
import script from "./ItemPool.vue?vue&type=script&lang=js&"
export * from "./ItemPool.vue?vue&type=script&lang=js&"
import style0 from "./ItemPool.vue?vue&type=style&index=0&id=d27f2e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27f2e2a",
  null
  
)

export default component.exports